import React, { useEffect,useState} from 'react';
import { Container, Grid, Typography, Button } from '@material-ui/core';
import Constants from '../../Constants';
import PubSub from 'pubsub-js';
import { useApolloClient } from '@apollo/client';
import ENDPOINT from '../graphql/GraphQLConstants';
import Loading from '../shared/Loading';
function TopUp(props) {
    const [isLoading,setIsLoading]=useState(false);
    const graphql = useApolloClient();
    useEffect(() => { 
            onloadTopupSelect();
    }, [props]);
    const handleChange = event => {
        for (let i = 0; i < document.getElementsByClassName('MuiButtonBase-root').length; i++) {
            document.getElementsByClassName('MuiButtonBase-root')[i].classList.remove('btn-purple');
        }
        if (event.target.classList.contains('MuiButtonBase-root'))
            event.target.classList.add('btn-purple');
        else event.target.parentNode.classList.add('btn-purple');
        setIsLoading(true);
        if(event.target.parentNode.getAttribute('value')){
            addTopup(event.target.parentNode.getAttribute('value'));
        }else{
            addTopup(event.target.getAttribute('value'));
        }
        
    };
    const addTopup = async amount => {
        try {
            let totalTopup = parseFloat(props.details.plan.price);
            if (amount != 0) {
                totalTopup = parseFloat(props.details.plan.price) + parseFloat(amount);
            }
            const res = await graphql.mutate({
                mutation: ENDPOINT.ADD_TOPUP,
                variables: {
                    prospectUuid: localStorage.getItem('prospectUuid'),
                    cartOfferId: parseInt(localStorage.getItem('offerId')),
                    topUpAmount: parseInt(totalTopup),
                },
            });
            if (res.data.topupAmount) {                             
                PubSub.publish(Constants.eventKeys.updatedCartDetails, res.data.topupAmount);                                
            }
        } catch (err) {
            console.log(err.message);
        }
    };
    const onloadTopupSelect = () => {
        setIsLoading(false); 
        if (props.details.topUpAmount) {
            let topupVal = (props.details.topUpAmount - props.details.plan.price);
            for (let i = 0; i < document.getElementsByClassName('btn-default').length; i++) {
                if (
                    topupVal ==
                    document.getElementsByClassName('btn-default')[i].getAttribute('value')
                )
                    document.getElementsByClassName('btn-default')[i].classList.add('btn-purple');
            }
        } else {
            document.getElementsByClassName('btn-default')[0].classList.add('btn-purple');
        }
    };
    return (
        <Container className='background'>
           {isLoading?<Loading className="m-5" />:
            <Grid container variant='outlined'>
                <Grid xs={12} sm={3}>
                    <h2 className='h2-title'>Your top up</h2>
                </Grid>
                <Grid xs={12} sm={9}>
                    <Grid>
                        <Typography className='topup-title'>
                            Do you want to add any additional credit to your plan?
                        </Typography>
                    </Grid>
                    
                    <Grid list>
                        {props.details.availableTopUp.map((topup)=>{
                            return(<Button
                                variant='outlined'
                                className='btn-default'
                                onClick={handleChange}
                                value={topup}>
                                &euro;{topup}
                            </Button>)})}                        
                    </Grid>
                </Grid>
            </Grid>}
        </Container>
    );
}
export default TopUp;
